._1dvqouq0 {
  display: flex;
  width: fit-content;
  gap: var(--xvl85n8x);
  background: var(--xvl85n2w);
  border-radius: var(--xvl85n9j);
  padding: var(--xvl85n97);
  border: 1px solid var(--xvl85nc);
}
._1dvqouq1 {
  padding: 6px 14px;
  border-radius: var(--xvl85n9i);
  border: none;
  background: transparent;
  color: var(--xvl85n8k);
  font-size: var(--xvl85n7q);
  font-weight: var(--xvl85n82);
  font-family: var(--xvl85n7l);
  cursor: pointer;
  transition: color var(--xvl85ndo), background var(--xvl85ndo);
  display: flex;
  align-items: center;
  gap: var(--xvl85n8z);
  white-space: nowrap;
  position: relative;
}
._1dvqouq1:hover {
  color: var(--xvl85n8j);
  background: var(--xvl85na);
}
._1dvqouq2 {
  background: linear-gradient(135deg, var(--xvl85nc) 0%, var(--xvl85ni7) 100%);
  color: var(--xvl85n18);
  box-shadow: var(--xvl85n2j), inset 0 1px 0 var(--xvl85n2z);
}
._1dvqouq5 {
  font-size: var(--xvl85n7p);
  padding: 4px 10px;
  border-radius: var(--xvl85n9h);
}
._1dvqouq6 {
  font-weight: var(--xvl85n83);
  background: var(--xvl85n25);
  color: var(--xvl85n8o);
  border-radius: var(--xvl85n9k);
  padding: 1px 6px;
  line-height: var(--xvl85n86);
}
._1dvqouq7 {
  font-size: var(--xvl85n7p);
}
._1dvqouq8 {
  font-size: var(--xvl85n7o);
}
._1dvqouqa {
  background: transparent;
  color: var(--xvl85n8k);
  font-weight: var(--xvl85n80);
  padding: 0;
}
[aria-selected="true"] ._1dvqouqa {
  color: var(--xvl85n8j);
}
@media (prefers-reduced-motion: reduce) {
  ._1dvqouq1 {
    transition: none;
  }
}
@media (max-width: 768px), (max-height: 500px) and (pointer: coarse) {
  ._1dvqouq0 {
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  ._1dvqouq1 {
    font-size: var(--xvl85n7p);
    min-height: 36px;
  }
  ._1dvqouq1::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    height: 44px;
    transform: translateY(-50%);
  }
}